import _ from 'lodash'

import {
  Model,
  LegacyPage,
  LoadingContainer,
  Panels,
  Bar,
  Modal,
} from 'peach/components'
import { useParams } from 'peach/router'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import {
  useInternalGenerateStatement,
  useGetLoanPeriodById,
  useInternalGetStatements,
} from 'core/types'

const LoanPeriod = () => {
  const { companyId, personId, loanId, periodId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
    periodId?: string
  }>()

  const { data: period, isLoading } = useGetLoanPeriodById({
    personId,
    loanId,
    loanPeriodId: periodId,
    options: { throwOnError: R.isNot(isNotFoundError) },
  })

  const {
    data: statements,
    isLoading: isStatementsLoading,
    refetch: refetchStatements,
  } = useInternalGetStatements({
    companyId,
    personId,
    loanId,
    options: { throwOnError: R.isNot(isNotFoundError) },
  })

  const statement = _.find(statements, { periodId })

  const { mutateAsync: createStatement } = useInternalGenerateStatement({
    companyId,
    personId,
    loanId,
    periodId,
  })

  return (
    <Panels header={<Bar title='Period' />}>
      <Modal
        initialValue={{}}
        onSubmit={async () => {
          await createStatement()
          _.delay(() => refetchStatements(), 1000)
        }}
        title='Generate Statement'
      />
      <LoadingContainer loading={isLoading || isStatementsLoading}>
        <LegacyPage.Full>
          <Model.Item json={period} title='Period' />
          {statement && <Model.Item json={statement} title='Statement' />}
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanPeriod
